import React from 'react'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'
import { useMultiplayerElementsSync } from '@/hooks/use-multiplayer-elements-sync'

export function MultiplayerSyncHandler({
  spreadId,
  shapeManagerRef,
  enabled = true,
  onRemoteTextBoxDeleted,
}: {
  spreadId: string
  shapeManagerRef: React.RefObject<ShapeManagerRef | null>
  enabled?: boolean
  onRemoteTextBoxDeleted?: (objectId: string, uid?: number) => void
}) {
  useMultiplayerElementsSync({
    spreadId,
    shapeManagerRef,
    enabled,
    onRemoteTextBoxDeleted,
  })
  return null
}
